import { formatWithOptions } from 'date-fns/fp'
import { fr } from 'date-fns/locale'
export const dateFormatLong = formatWithOptions({ locale: fr }, 'd MMMM Y')
export const dateFormatMonthYear = formatWithOptions({ locale: fr }, 'MMMM Y')
export const dateFormatYearMonth = formatWithOptions({ locale: fr }, 'yyyy-LL')
